import { render, staticRenderFns } from "./ExplorationSubCard.vue?vue&type=template&id=b1fdd062&scoped=true&"
import script from "./ExplorationSubCard.vue?vue&type=script&lang=js&"
export * from "./ExplorationSubCard.vue?vue&type=script&lang=js&"
import style0 from "./ExplorationSubCard.vue?vue&type=style&index=0&id=b1fdd062&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fdd062",
  null
  
)

export default component.exports